import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { BackButton } from "../../../../../../components/primaryComponents";
import { useEditBills } from "./useEditBills";
import { BillsForm } from "../../../../../../components/secondaryComponents/Bills";

export const EditBills = () => {
  const { isLoading, billsDetails } = useEditBills({});

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Update Bills"
      description="Update bills that was created in the past."
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div className="d-flex align-items-center">
            <BackButton />
            <h4 className="ml-2 mb-0">
              <span className="gray--text">Bill Number: </span>{" "}
              {billsDetails?.bill_number}
            </h4>
          </div>

          <secondaryComponents.LoaderHelper
            classNames={"mt-5"}
            isLoading={isLoading}
          >
            <BillsForm isEditMode={true} billsDetails={billsDetails} />
          </secondaryComponents.LoaderHelper>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
